import { render, staticRenderFns } from "./CustomerQuantityCard.vue?vue&type=template&id=3be38443&scoped=true&"
import script from "./CustomerQuantityCard.vue?vue&type=script&lang=ts&"
export * from "./CustomerQuantityCard.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerQuantityCard.vue?vue&type=style&index=0&id=3be38443&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be38443",
  null
  
)

export default component.exports